import { render } from "./DetailsPassings.vue?vue&type=template&id=b6065316&scoped=true"
import script from "./DetailsPassings.vue?vue&type=script&lang=js"
export * from "./DetailsPassings.vue?vue&type=script&lang=js"

import "./DetailsPassings.vue?vue&type=style&index=0&id=b6065316&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6065316"]])

export default __exports__